import { DeviceType, NoResponse } from "@virtualprogaming/js-public-sdk";
import { AxiosResponse } from "axios";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { NOTIFICATIONS_BY_USER } from "~/constants";

import { useNotificationsApi } from "./api";

export function useDeleteAllNotificationsByDevice(
  options?: UseMutationOptions<AxiosResponse<NoResponse>>
) {
  const api = useNotificationsApi();
  const queryClient = useQueryClient();
  return useMutation(() => api.deleteAllNotificationsByDevice(DeviceType.Web), {
    onSuccess: async () => {
      await queryClient.invalidateQueries([NOTIFICATIONS_BY_USER]);
    },
    ...options,
  });
}
